import { Box } from "@mui/material";
import { blue } from "@mui/material/colors";
import type { FormulaHighlightType } from "./utilities/customFormulaHighlight";
import { splitFormulaHighlightSegments } from "./utilities/customFormulaHighlight";
import type { FormulaReferenceField } from "./utilities/customFormulaParser";

interface Props {
  formulaInput: string;
  scrollTop: number;
  referenceFields: FormulaReferenceField[];
}

const highlightColorMap: Record<FormulaHighlightType, string | undefined> = {
  none: undefined,
  field: undefined,
  function: blue[700],
};

const CustomFormulaHighlightedText = ({ formulaInput, scrollTop, referenceFields }: Props) => {
  const segments = splitFormulaHighlightSegments(formulaInput, referenceFields);

  return (
    <Box sx={{ position: "absolute", inset: 0, overflow: "hidden", pointerEvents: "none", zIndex: 0 }}>
      <Box
        sx={(theme) => ({
          transform: `translateY(-${scrollTop}px)`,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          lineHeight: "24px",
          color: theme.palette.text.primary,
        })}
      >
        {segments.map((segment, index) => (
          <Box
            component="span"
            // eslint-disable-next-line @eslint-react/no-array-index-key
            key={`${segment.text}-${index}`}
            sx={(theme) => ({
              color:
                highlightColorMap[segment.highlightType] ??
                (segment.highlighted ? theme.palette.warning.dark : "inherit"),
            })}
          >
            {segment.text}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CustomFormulaHighlightedText;
